export default "__VITE_ASSET__6172e680__"